import { useField } from "formik";
import { Input } from "taltech-styleguide";
import { InputBase } from "./InputBase";

export const InputSelectAsync = (props: {
  id: string;
  source: { type: string };
  selected?: string;
  label?: string;
  options: any[];
  elementClass?: string;
}) => {
  const [field, meta, helpers] = useField(props.id);
  const { id, ...rest } = props;

  const OptionsInner = () => {
    const selected = props.selected || field.value;
    return (
      <div className={`${props.elementClass ? props.elementClass : ""}`}>
        <Input
          as="select"
          value={selected}
          onChange={(evt) => {
            helpers.setValue(evt.target.value);
          }}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
          //disabled={disabled}
        >
          {rest.options.map((x) => (
            <option key={x.value} value={x.value}>
              {x.text.toString()}
            </option>
          ))}
        </Input>
      </div>
    );
  };

  const innerProps = {
    id,
    //  disabled,
    ...rest,
    renderAs: "select",
    component: OptionsInner,
  };

  return <InputBase {...innerProps} />;
};
